import { Network } from '@capacitor/core';
import { Injectable } from '@angular/core';
import { ConnectivityFacade } from '../+state';

@Injectable()
export class ConnectivityService {
  constructor(private connectivityFacade: ConnectivityFacade) {}

  public startCheckConnectivity(): void {
    this.initializeWifiStatus();
    this.addListenertOnStatusChange();
  }

  private initializeWifiStatus(): void {
    Network.getStatus().then((status) => {
      this.connectivityFacade.changeWifiConnectivity(status.connected);
    });
  }

  private addListenertOnStatusChange(): void {
    Network.addListener('networkStatusChange', (status) => {
      this.connectivityFacade.changeWifiConnectivity(status.connected);
    });
  }
}
